import React from 'react';
import FileUpload from '@material-ui/icons/CloudUpload';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { artifactStatusMap } from '../../../Constants/Files';
import { makeStyles } from '@material-ui/core/styles';
import CustomToolTip from '../../common/CustomToolTip';
import {addFileToArtifact} from "../../../redux/actions/manageAssetActions";

const useStyles = makeStyles(() => ({
	textTransformNone: {
		textTransform: 'none',
	},
}));
const ArtifactOverwriteBtn = ({ artifact }) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const handleFileOnChange = (event) => {
		const file = event.target.files[0];
		dispatch(addFileToArtifact(artifact, file));
		event.target.value = null;
	};
	return (
		<CustomToolTip
			title= {
			(artifact.status === artifactStatusMap.published.value || artifact.status === artifactStatusMap.live.value) ?
				`Cannot overwrite an artifact with the status of ${artifact.status}.`:
				'Upload file to overwrite artifact.'
			}
			InnerComponent={
				<div>
					<input
						id={'artifact-upload' + artifact.id}
						hidden
						type="file"
						accept={'.' + artifact.type}
						onChange={handleFileOnChange}
					/>
					<label htmlFor={'artifact-upload' + artifact.id}>
						<Button
							component="span"
							color="primary"
							size="large"
							disabled={
								artifact.status === artifactStatusMap.published.value ||
								artifact.status === artifactStatusMap.live.value
							}
							startIcon={<FileUpload />}
							className={classes.textTransformNone}
						>
							Upload
						</Button>
					</label>
				</div>
			}
		/>
	);
};

export default ArtifactOverwriteBtn;
